import { createUseStyles } from "react-jss";

const styles = createUseStyles({
  flightSegmentsTab: {
    //
  }
});

export default styles;
